<template lang="html">


  <div class="pe_toggle-switch">
    <label>{{ label }}</label>
    <div
      class="pe_toggle"
      :class="{'pe_active': model}"
      @click="$emit('changed', !model)">
      <div
        class="pe_draggable"
        :style="style">
      </div>
    </div>
    <span class="pe_toggle_tooltip">
      <svg xmlns="http://www.w3.org/2000/svg" height="15px" viewBox="0 0 24 24" width="15px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/></svg>
      
      <span class="pe_tooltiptext">{{ TooltipText }}</span>
    </span>
  </div>

</template>

<script lang="js">

  export default  {
    name: 'toggle-switch',
    props: ['label', 'model', 'showTooltip', 'TooltipText'],

    computed: {
      style() {
        let percent = this.model ? '100%' : '0%'
        return {
          transform: `translateX(${ percent })`
        }
      },
      doShowTooltip(){
        return true
      }
    },

    
}


</script>

<style scoped lang="scss">

@import '@puzzleapps/shared/src/style/variables';

  $button-size: 15px;

  .pe_toggle-switch {
    display:flex;
    justify-content: flex-end;
    font-size: 0.9em;
    letter-spacing: 1px;
    color: var(--default-font-color);
    
    
  }

  .pe_toggle_tooltip{
      /*display:flex;
      align-items: center;*/
      position: relative;
      display: inline-block;
      font-size: 12px;
      padding: 3px 0 0 5px;
    }
    .pe_toggle_tooltip .pe_tooltiptext {
        visibility: hidden;
        width: 180px;
        background-color: #000;
        color: #fff;
        text-align: center;
        font-weight: 600;
        border-radius: 6px;
        padding: 5px 5px;
        max-width: 180px!important;
        min-width: 125px!important;

        /* Position the tooltip above the mouse */
        position: absolute;
        z-index: 1;
        bottom: 120%;
        //left: 50%;
        margin-left: -180px;
    }

    .pe_toggle_tooltip:hover .pe_tooltiptext {
        visibility: visible;
    }

  .pe_toggle {
    margin-left: 1em;
    width: $button-size * 2;
    height: $button-size;
    background: #ccc;
    border: 2px solid rgb(177, 173, 173);
    border-radius: 200px;
    padding: 2px;
    transition: background 0.6s;
    cursor: pointer;
    -webkit-box-sizing:content-box!important;
    box-sizing: content-box!important;
    
    .pe_draggable {
      width: $button-size;
      height: $button-size;
      background: #fff;
      border-radius: 100%;
      box-shadow: 0px 2px 8px rgba(0,0,0, 0.3);
      transform: translateX(0%);
      transition: transform 0.05s ease-in-out;
    }
    
    &.pe_active {
      background: rgb(24, 136, 2);
      transition: transparent 0.6s;
    }
  }

</style>
